import * as R from 'ramda';
import { isBefore, parseISO } from 'date-fns/fp';
import { startOfToday } from 'date-fns/esm';

export const isExpired = R.pipe(parseISO, isBefore(startOfToday()));
